// client/src/services/venueService.js
import axios from '../utils/axiosConfig';

export const getMyProfile = () => axios.get('/venue/profile').then(r => r.data.profile);
export const updateMyProfile = (data) => axios.put('/venue/profile', data).then(r => r.data.profile);
export const submitVerificationDocuments = (documents) =>
  axios.post('/venue/verification-documents', { documents }).then(r => r.data.profile);

export const addRoom = (room) => axios.post('/venue/rooms', room).then(r => r.data.profile);
export const updateRoom = (roomId, data) => axios.put(`/venue/rooms/${roomId}`, data).then(r => r.data.profile);
export const deleteRoom = (roomId) => axios.delete(`/venue/rooms/${roomId}`).then(r => r.data.profile);
export const setRoomAvailability = (roomId, slots) =>
  axios.post(`/venue/rooms/${roomId}/availability`, { slots }).then(r => r.data.created);
export const getRoomAvailability = (roomId, date) =>
  axios.get(`/venue/rooms/${roomId}/availability`, { params: { date } }).then(r => r.data.slots);

export const upsertOwnService = (service) => axios.post('/venue/services', service).then(r => r.data.profile);
export const deleteOwnService = (serviceId) => axios.delete(`/venue/services/${serviceId}`).then(r => r.data.profile);

export const getMyOrders = () => axios.get('/venue/orders').then(r => r.data.orders);
